var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showTooltip)?_c('span',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"color":"warning"}},[_vm._v(_vm._s(_vm.icon))])],1)]}}],null,false,2286024149)},[_c('span',[_vm._v(" "+_vm._s(_vm.tooltipText)+" ")])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }